import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const chatTag = "Chat";

type SessionStatus = "active" | "inactive" | "both";
type ChatType = "chat" | "conference" | "group" | "a2a" | "any";

export type GetChatRoomsParams = {
  personal?: boolean;
  "chat-type"?: ChatType;
  "session-status"?: SessionStatus;
  include?: "messages"; // Include initial_messages in response
  message_limit?: number; // Number of messages per room (default: 25)
  page?: number; // Page number for pagination (default: 1)
  limit?: number; // Number of rooms per page (default: 20)
};

export type GetMessagesParams = {
  sessionKey: string;
  page?: number;
  limit?: number;
  start_from?: 'first_unread' | 'latest';
  after_message_id?: string;  // Load messages AFTER this message (newer)
  before_message_id?: string; // Load messages BEFORE this message (older)
};

export type GetParticipantsParams = {
  sessionKey: string;
};

const chatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatRooms: builder.query<any, GetChatRoomsParams | void>({
      query: (params) => {
        if (!params) {
          return `/chat/rooms`;
        }
        // Build query params directly (flattenQueryParams only handles filters/pagination)
        const searchParams = new URLSearchParams();
        if (params.personal !== undefined) {
          searchParams.append('personal', String(params.personal));
        }
        if (params["chat-type"]) {
          searchParams.append('chat-type', params["chat-type"]);
        }
        if (params["session-status"]) {
          searchParams.append('session-status', params["session-status"]);
        }
        if (params.include) {
          searchParams.append('include', params.include);
        }
        if (params.message_limit !== undefined) {
          searchParams.append('message_limit', String(params.message_limit));
        }
        if (params.page !== undefined) {
          searchParams.append('page', String(params.page));
        }
        if (params.limit !== undefined) {
          searchParams.append('limit', String(params.limit));
        }
        const queryString = searchParams.toString();
        return `/chat/rooms${queryString ? `?${queryString}` : ''}`;
      },
      providesTags: [chatTag],
    }),

    getChatRoomParticipants: builder.query<any, GetParticipantsParams>({
      query: ({ sessionKey }) => {
        console.log("session keyyy", sessionKey)
        const safeKey = encodeURIComponent(sessionKey);
        return `/chat/rooms/${safeKey}/participants`;
      },
      providesTags: (result, error, { sessionKey }) => [{ type: chatTag, id: `p:${sessionKey}` }],
    }),
getChatRoomMessages: builder.query<any, GetMessagesParams>({
  query: ({ sessionKey, page = 1, limit = 20, start_from, after_message_id, before_message_id }) => {
    const safeKey = encodeURIComponent(sessionKey);
    console.log("messages API params:", { page, limit, start_from, after_message_id, before_message_id });

    // Build params object
    const params: Record<string, any> = { limit };

    // Cursor-based pagination takes priority
    if (after_message_id) {
      params.after_message_id = after_message_id;
    } else if (before_message_id) {
      params.before_message_id = before_message_id;
    } else if (start_from) {
      params.start_from = start_from;
    } else {
      params.page = page;
    }

    return {
      url: `/chat/rooms/${safeKey}/messages`,
      params,
    };
  },
  providesTags: (result, error, { sessionKey }) => [{ type: chatTag, id: `m:${sessionKey}` }],
}),
  }),
});

export const {
  useGetChatRoomsQuery,
  useGetChatRoomParticipantsQuery,
  useGetChatRoomMessagesQuery,
  useLazyGetChatRoomMessagesQuery
} = chatApi;

export default chatApi;
